import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import DepartmentHome from "./DepartmentHome";

export default function DepartmentList() {
  return (
     <Fragment>
            <Breadcrumbs mainTitle="List of Departments" parent="Home" title="List of Departments" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <DepartmentHome/>
                    </Col>
                </Row>
            </Container>
        </Fragment>
  )
}
